import React from 'react';
import ProtectedRoute from '../../components/ProtectedRoute/ProtectedRoute';
import GoogleCallback from '../../features/auth/components/GoogleCallback';

const GoogleCallbackRoute = () => {
  return (
    <ProtectedRoute requiresAuth={false}>
      <GoogleCallback />
    </ProtectedRoute>
  );
};

export default GoogleCallbackRoute;
